"use client";
import { useState } from "react";
import { isEmpty, isValidEmail } from "@/app/utils/Validations";
import { FormattedMessage } from "react-intl";
import { sendForm } from "@/app/services/FormService";
import styles from "@/app/styles/components/pages/corporate-gifts/corporate-gifts-form.module.scss";

const ContactForm = () => {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [messageText, setMessageText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState("");
  const formId = "419";

  const resetForm = () => {
    setData({
      name: "",
      email: "",
      topic: "",
      message: ""
    });
    setErrors({});
  }

  const handleChangeData = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const getFormErrors = () => {
    let formErrors = {};

    if (isEmpty(data?.name)) {
      formErrors.name = (
        <FormattedMessage id={"common.errors.thisFieldIsRequired"} />
      );
    }
    if (!isValidEmail(data?.email)) {
      formErrors.email = (
        <FormattedMessage id={"common.errors.emailIsNotValid"} />
      );
    }
    if (isEmpty(data?.topic)) {
      formErrors.topic = (
        <FormattedMessage id={"common.errors.thisFieldIsRequired"} />
      );
    }
    if (isEmpty(data?.message)) {
      formErrors.message = (
        <FormattedMessage id={"common.errors.thisFieldIsRequired"} />
      );
    }

    return formErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessageText("");
    const formErrors = getFormErrors();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);
    let formData = new FormData();
    formData.append("your-name", data.name);
    formData.append("your-email", data.email);
    formData.append("your-topic", data.topic);
    formData.append("your-message", data.message);
    formData.append("_wpcf7_unit_tag", "wpcf7-f7de8154-1");


    sendForm(formId, formData)
      .then((response) => {
        setData({});
        setIsLoading(false);
        setMessageText(response.message);
        resetForm();
        setMessageSent(true);
      })
      .catch(error => {
        setIsLoading(false);
        setFormErrorMessage(common.sendError);
        setMessageSent(false);
      });
  };

  return (
    <>
      <div className={styles.formContainer}>
        <form onSubmit={handleSubmit} className="formStyle">
          <div className="inputContainer">
            <FormattedMessage
              id={"components.pages.corporateGifts.corporateGiftsForm.name"}
            >
              {(message) => (
                <input
                  id="name-input-gift"
                  type="text"
                  value={data.name}
                  name="ime"
                  placeholder={message}
                  autoComplete="off"
                  onChange={(e) => handleChangeData("name", e.target.value)}
                />
              )}
            </FormattedMessage>
            {errors?.name && (
              <div className="errorMessage">{errors?.name}</div>
            )}
          </div>
          <div className="inputContainer">
            <FormattedMessage
              id={"components.pages.corporateGifts.corporateGiftsForm.email"}
            >
              {(message) => (
                <input
                  id="email-input-gift"
                  type="email"
                  value={data.email}
                  placeholder={message}
                  autoComplete="off"
                  onChange={(e) => handleChangeData("email", e.target.value)}
                />
              )}
            </FormattedMessage>
            {errors?.email && (
              <div className="errorMessage">{errors?.email}</div>
            )}
          </div>
          <div className="inputContainer">
            <FormattedMessage
              id={"components.pages.corporateGifts.corporateGiftsForm.topic"}
            >
              {(message) => (
                <input
                  id="topic-input-gift"
                  type="text"
                  value={data.topic}
                  placeholder={message}
                  autoComplete="off"
                  onChange={(e) => handleChangeData("topic", e.target.value)}
                />
              )}
            </FormattedMessage>
            {errors?.company && (
              <div className="errorMessage">{errors?.company}</div>
            )}
          </div>
          <div className="inputContainer">
            <FormattedMessage
              id={"components.pages.corporateGifts.corporateGiftsForm.message"}
            >
              {(message) => (
                <textarea
                  id="message-input-gift"
                  value={data.message}
                  placeholder={message}
                  onChange={(e) => handleChangeData("message", e.target.value)}
                />
              )}
            </FormattedMessage>
            {errors?.message && (
              <div className="errorMessage">{errors?.message}</div>
            )}
          </div>

          <div className="buttonContainer">
            <button className="submit-btn btnGlobal">
              <FormattedMessage id={"common.send"} />
            </button>
          </div>

          {isLoading && (
            <div className="sending">
              <FormattedMessage id={"common.sending"} />
            </div>
          )}
          {messageSent && <div className="success-message">{messageText}</div>}
          {formErrorMessage && <div className="error-message-2">{formErrorMessage}</div>}
        </form>
      </div>
    </>
  );
};

export default ContactForm;
